import React, { useState } from 'react';
import AnimateHeight from 'react-animate-height';
import { ChevronDown } from '@gjensidige/builders-icons';
import { Title, Text } from '@gjensidige/builders-components';
import './SelectionSummary.scss';
import { AppConstants } from '../../utils/AppConstants';
import { SummarySection } from './SummarySection';

interface SelectionSummaryProps {
  selections: {
    selectedPackageName: string;
    selectedPackagePrice: string;
    summaryBrief?: {
      sectionHeader?: string;
      selections?: {
        label: string;
        value: string;
        noLineBreakOnValue?: boolean;
      }[];
    }[];
    summaryDetails?: {
      sectionHeader?: string;
      selections?: {
        label: string;
        value: string;
        noLineBreakOnValue?: boolean;
      }[];
    }[];
  };
  isExpandCollapseEnabled: boolean;
}
export const SelectionSummary: React.FC<SelectionSummaryProps> = (
  props: SelectionSummaryProps
) => {
  const [isExpanded, setIsExpanded] = useState(false);
  return (
    <div className="selection-summary-section">
      <div className="selected-package-info summary-block">
        <Title as="h2" size="4">{props.selections.selectedPackageName}</Title>
        <div className="selected-package-price">
          <Text weight="700" size="lead" className="summary-price-label">{props.selections.selectedPackagePrice}</Text>
          <Text weight="700" size="body">{AppConstants.getAppText('webshop.totalPrice.payementFrequecy.label')}</Text>
        </div>
      </div>
      <div className="selected-summary-info summary-block">
        <div className="selected-brief-wrapper">
          {props.selections?.summaryBrief &&
            props.selections?.summaryBrief.length > 0 &&
            props.selections?.summaryBrief.map((summary, index) => {
              return (
                <div className="summary-sections" key={index}>
                  <SummarySection summary={summary} />
                </div>
              );
            })}
        </div>
        <AnimateHeight
          height={
            props.isExpandCollapseEnabled ? (isExpanded ? 'auto' : 0) : 'auto'
          }
          duration={400}
          easing={'cubic-bezier(0, 0.45, 0.2, 0.99)'}
          aria-hidden={false}
        >
          <div className="selected-details-wrapper">
            {props.selections?.summaryDetails &&
              props.selections?.summaryDetails.length > 0 &&
              props.selections?.summaryDetails.map((summary, index) => {
                return (
                  <div className="summary-sections mt-3" key={index}>
                    <SummarySection summary={summary} />
                  </div>
                );
              })}
          </div>
        </AnimateHeight>
      </div>
      {props.isExpandCollapseEnabled && (
        <div className="expand-collapse-wrapper pb-3">
          <button
            className="expand-collapse-button"
            onClick={() => setIsExpanded(!isExpanded)}
            aria-expanded={isExpanded ? 'true' : 'false'}
          >
            <Text size="body" className="expand-button-label">
              {!isExpanded
                ? AppConstants.getAppText('webshop.summary.expandButtonLabel')
                : AppConstants.getAppText(
                  'webshop.summary.collapseButtonLabel'
                )}
            </Text>
            <ChevronDown
              className={`icon-arrow ${!isExpanded ? 'arrow-down' : 'arrow-up'
                }`}
              color="#F4FFAF"
            />
          </button>
        </div>
      )}
    </div>
  );
};
